import UserAuth from "components/AuthGaurd/UserAuth";
import ActiveUsers from "components/dashboard/Users/ActiveUsers";
import DashboardHeroSection from "components/dashboard/DashboardHeroSection";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import React from "react";

const Users = () => {
  return (
    <UserAuth>
      <header>
        <Header admin={true} />
      </header>

      {/* hero section */}
      <DashboardHeroSection title="Activation Code">
        <ActiveUsers />
      </DashboardHeroSection>

      <footer className="tw-flex">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default Users;
